import React from 'react';
import { Loader } from '@consta/uikit/Loader';
import cn from 'classnames/bind';
import styles from './styles.styl';

const cx = cn.bind(styles);

export interface IStaffsTableLoaderProps {
  height?: string;
}

const StaffsTableLoader: React.FC<IStaffsTableLoaderProps> = ({ height }) => {
  return (
    <div className={cx('TableLoader')} style={{ height }}>
      <Loader />
    </div>
  );
};

export default StaffsTableLoader;
